export default __webpack_public_path__ + "static/media/findit-twc-40x40.0e3bc612.webp";